var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-container" }, [
    _c("div", { staticClass: "panel-container" }, [
      _vm._m(0),
      _c("div", { staticClass: "panel-box" }, [
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                _c("el-col", {
                  staticClass: "panel-img flowInstances-wait",
                  attrs: { span: 5 }
                }),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("待办流程")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("待办流程查看，审批")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "div",
                { staticClass: "link-text" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "f-12",
                      attrs: { to: "/flowInstances/wait" }
                    },
                    [
                      _vm._v("点击进入 "),
                      _c("i", { staticClass: "icon el-icon-arrow-right" })
                    ]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                _c("el-col", {
                  staticClass: "panel-img flowInstances-index",
                  attrs: { span: 5 }
                }),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("我的流程")
                    ]),
                    _c("div", { staticClass: "f-12" }, [_vm._v("申请编辑流程")])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "div",
                { staticClass: "link-text" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "f-12",
                      attrs: { to: "/flowInstances/Index" }
                    },
                    [
                      _vm._v("点击进入 "),
                      _c("i", { staticClass: "icon el-icon-arrow-right" })
                    ]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                _c("el-col", {
                  staticClass: "panel-img flowInstances-disposed",
                  attrs: { span: 5 }
                }),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("已办流程")
                    ]),
                    _c("div", { staticClass: "f-12" }, [_vm._v("已办流程查看")])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "div",
                { staticClass: "link-text" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "f-12",
                      attrs: { to: "/flowInstances/disposed" }
                    },
                    [
                      _vm._v("点击进入 "),
                      _c("i", { staticClass: "icon el-icon-arrow-right" })
                    ]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                _c("el-col", {
                  staticClass: "panel-img sysMessages-Index",
                  attrs: { span: 5 }
                }),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("我的消息")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("待办流程查看，审批")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "div",
                { staticClass: "link-text" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "f-12",
                      attrs: { to: "/SysMessages/Index" }
                    },
                    [
                      _vm._v("点击进入 "),
                      _c("i", { staticClass: "icon el-icon-arrow-right" })
                    ]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                _c("el-col", {
                  staticClass: "panel-img sysLogs-Index",
                  attrs: { span: 5 }
                }),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("系统日志")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("日志搜索、查看")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "div",
                { staticClass: "link-text" },
                [
                  _c(
                    "router-link",
                    { staticClass: "f-12", attrs: { to: "/SysLogs/Index" } },
                    [
                      _vm._v("点击进入 "),
                      _c("i", { staticClass: "icon el-icon-arrow-right" })
                    ]
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ]),
      _c("div", { staticClass: "panel-box" }, [
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                _c("el-col", {
                  staticClass: "panel-img roleManager-Index",
                  attrs: { span: 5 }
                }),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("角色管理")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("系统角色分配、删除管理")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "div",
                { staticClass: "link-text" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "f-12",
                      attrs: { to: "/RoleManager/Index" }
                    },
                    [
                      _vm._v("点击进入 "),
                      _c("i", { staticClass: "icon el-icon-arrow-right" })
                    ]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                _c("el-col", {
                  staticClass: "panel-img userManager-Index",
                  attrs: { span: 5 }
                }),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("用户管理")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("系统用户增删改查")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "div",
                { staticClass: "link-text" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "f-12",
                      attrs: { to: "/UserManager/Index" }
                    },
                    [
                      _vm._v("点击进入 "),
                      _c("i", { staticClass: "icon el-icon-arrow-right" })
                    ]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                _c("el-col", {
                  staticClass: "panel-img forms-index",
                  attrs: { span: 5 }
                }),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("表单设计")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("系统表单增加、修改")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "div",
                { staticClass: "link-text" },
                [
                  _c(
                    "router-link",
                    { staticClass: "f-12", attrs: { to: "/forms/index" } },
                    [
                      _vm._v("点击进入 "),
                      _c("i", { staticClass: "icon el-icon-arrow-right" })
                    ]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                _c("el-col", {
                  staticClass: "panel-img flowSchemes-index",
                  attrs: { span: 5 }
                }),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("流程设计")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("系统流程增加、修改")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "div",
                { staticClass: "link-text" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "f-12",
                      attrs: { to: "/flowSchemes/index" }
                    },
                    [
                      _vm._v("点击进入 "),
                      _c("i", { staticClass: "icon el-icon-arrow-right" })
                    ]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                _c("el-col", {
                  staticClass: "panel-img uploadfiles-index",
                  attrs: { span: 5 }
                }),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("附件管理")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("系统附件查看，检索")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "div",
                { staticClass: "link-text" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "f-12",
                      attrs: { to: "/uploadfiles/index" }
                    },
                    [
                      _vm._v("点击进入 "),
                      _c("i", { staticClass: "icon el-icon-arrow-right" })
                    ]
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ])
    ]),
    _c("div", { staticClass: "panel-container" }, [
      _vm._m(1),
      _c("div", { staticClass: "m-t-24 panel-box" }, [
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                !_vm.isDisabled
                  ? _c("el-col", {
                      staticClass: "panel-img information",
                      attrs: { span: 5 }
                    })
                  : _vm._e(),
                _vm.isDisabled
                  ? _c("el-col", {
                      staticClass: "panel-img information-disable",
                      attrs: { span: 5 }
                    })
                  : _vm._e(),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("发布通知")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("系统版本发布，请及时更新")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              !_vm.isDisabled
                ? _c(
                    "div",
                    { staticClass: "link-text" },
                    [
                      _c(
                        "router-link",
                        { staticClass: "f-12", attrs: { to: "/" } },
                        [
                          _vm._v("点击进入 "),
                          _c("i", { staticClass: "icon el-icon-arrow-right" })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isDisabled
                ? _c("div", { staticClass: "link-text-disable" }, [
                    _c("span", { staticClass: "f-12" }, [_vm._v("点击进入")])
                  ])
                : _vm._e()
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                !_vm.isDisabled
                  ? _c("el-col", {
                      staticClass: "panel-img operation-manual",
                      attrs: { span: 5 }
                    })
                  : _vm._e(),
                _vm.isDisabled
                  ? _c("el-col", {
                      staticClass: "panel-img operation-manual-disable",
                      attrs: { span: 5 }
                    })
                  : _vm._e(),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("操作手册")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("常用操作手册、视频等")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              !_vm.isDisabled
                ? _c(
                    "div",
                    { staticClass: "link-text" },
                    [
                      _c(
                        "router-link",
                        { staticClass: "f-12", attrs: { to: "/" } },
                        [
                          _vm._v("点击进入 "),
                          _c("i", { staticClass: "icon el-icon-arrow-right" })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isDisabled
                ? _c("div", { staticClass: "link-text-disable" }, [
                    _c("span", { staticClass: "f-12" }, [_vm._v("点击进入")])
                  ])
                : _vm._e()
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                !_vm.isDisabled
                  ? _c("el-col", {
                      staticClass: "panel-img software",
                      attrs: { span: 5 }
                    })
                  : _vm._e(),
                _vm.isDisabled
                  ? _c("el-col", {
                      staticClass: "panel-img software-disable",
                      attrs: { span: 5 }
                    })
                  : _vm._e(),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("常用软件")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("常用软件下载，一站式服务")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              !_vm.isDisabled
                ? _c(
                    "div",
                    { staticClass: "link-text" },
                    [
                      _c(
                        "router-link",
                        { staticClass: "f-12", attrs: { to: "/" } },
                        [
                          _vm._v("点击进入 "),
                          _c("i", { staticClass: "icon el-icon-arrow-right" })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isDisabled
                ? _c("div", { staticClass: "link-text-disable" }, [
                    _c("span", { staticClass: "f-12" }, [_vm._v("点击进入")])
                  ])
                : _vm._e()
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                !_vm.isDisabled
                  ? _c("el-col", {
                      staticClass: "panel-img suggestions",
                      attrs: { span: 5 }
                    })
                  : _vm._e(),
                _vm.isDisabled
                  ? _c("el-col", {
                      staticClass: "panel-img suggestions-disable",
                      attrs: { span: 5 }
                    })
                  : _vm._e(),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("意见建议")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("系统建议、意见反馈")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              !_vm.isDisabled
                ? _c(
                    "div",
                    { staticClass: "link-text" },
                    [
                      _c(
                        "router-link",
                        { staticClass: "f-12", attrs: { to: "/" } },
                        [
                          _vm._v("点击进入 "),
                          _c("i", { staticClass: "icon el-icon-arrow-right" })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isDisabled
                ? _c("div", { staticClass: "link-text-disable" }, [
                    _c("span", { staticClass: "f-12" }, [_vm._v("点击进入")])
                  ])
                : _vm._e()
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "common-panel" },
          [
            _c(
              "el-row",
              [
                !_vm.isDisabled
                  ? _c("el-col", {
                      staticClass: "panel-img online",
                      attrs: { span: 5 }
                    })
                  : _vm._e(),
                _vm.isDisabled
                  ? _c("el-col", {
                      staticClass: "panel-img online-disable",
                      attrs: { span: 5 }
                    })
                  : _vm._e(),
                _c(
                  "el-col",
                  { staticClass: "margin-12", attrs: { span: 17 } },
                  [
                    _c("div", { staticClass: "tem-title" }, [
                      _vm._v("在线咨询")
                    ]),
                    _c("div", { staticClass: "f-12" }, [
                      _vm._v("在线客服服务、专业咨询")
                    ])
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "link-container" }, [
              !_vm.isDisabled
                ? _c(
                    "div",
                    { staticClass: "link-text" },
                    [
                      _c(
                        "router-link",
                        { staticClass: "f-12", attrs: { to: "/" } },
                        [
                          _vm._v("点击进入 "),
                          _c("i", { staticClass: "icon el-icon-arrow-right" })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isDisabled
                ? _c("div", { staticClass: "link-text-disable" }, [
                    _c("span", { staticClass: "f-12" }, [_vm._v("点击进入")])
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "level-1-heading" }, [
      _c("span", { staticClass: "title-icon" }),
      _c("span", { staticClass: "title" }, [_vm._v(" 常用模块")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "level-1-heading" }, [
      _c("span", { staticClass: "title-icon" }),
      _c("span", { staticClass: "title" }, [_vm._v(" 常用帮助")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }